import React, { useState} from 'react';
import SelectField from '../../../../forms/selectOption';
import { MODALS } from '../../../../../config/images';
const AtcObs = ({ 
  isOpen, 
  onClose, 
  onSubmit, 
  title
}) => {
  const [observationText, setObservationText] = useState('');
  const [selectedReason, setSelectedReason] = useState('');

  const MAX_DESCRIPTION_LENGTH = 500;

  const handleSubmit = () => {
    if (observationText.trim() && selectedReason) {
      onSubmit({
        reason: selectedReason, 
        observation: observationText
      });
      setObservationText('');
      setSelectedReason('');
    }
  };

  const handleClose = () => {
    setObservationText('');
    setSelectedReason('');
    onClose();
  };

  if (!isOpen) return null;

  const reasonOptions = [
    { value: "Servicio duplicado", label: "Servicio duplicado" },
    { value: "Servicio no ejecutado", label: "Servicio no ejecutado" },
    { value: "Otro", label: "Otro" }
  ];

  const handleObservationChange = (e) => {
    const inputText = e.target.value;
    if (inputText.length <= MAX_DESCRIPTION_LENGTH) {
      setObservationText(inputText);
    }
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="w-[30%] p-4 bg-white rounded-[29px]">
        <div className="flex justify-end w-full ">
            <button
              onClick={handleClose}
            >
              <img src={MODALS.CLOSE} alt="cerrar"/>
            </button>
        </div>

        <div className='flex flex-col gap-3 px-6'>
            <p className="text-sm font-itcdemi">
                Seleccione el motivo: <span className="text-red">*</span>
            </p>

            <SelectField
                name="reason"
                value={selectedReason}
                onChange={(e) => setSelectedReason(e.target.value)}
                placeholder='Seleccione un motivo'
                options={reasonOptions}
            />

            <div className='flex items-center justify-between'>
              <p className="text-sm font-itcdemi">
                Describa: <span className="text-red">*</span>
              </p>
              <span className={`text-xs ${observationText.length >= MAX_DESCRIPTION_LENGTH ? 'text-red-500' : 'text-gray-500'}`}>
                {observationText.length}/{MAX_DESCRIPTION_LENGTH}
              </span>
            </div>
              
            <textarea
                value={observationText}
                onChange={handleObservationChange}
                placeholder="Describa"
                className="w-full h-[125px] p-3 border text-[13px] border-1 border-[#D1D5DB] rounded-md focus:outline-none  font-itcbook"
            />
            {observationText.length >= MAX_DESCRIPTION_LENGTH && (
              <p className="text-xs text-red font-itcbook">Has alcanzado el límite máximo de caracteres</p>
            )}
        </div>
        <div className='flex items-center justify-center'>
            <button
                onClick={handleSubmit}
                disabled={!observationText.trim() || !selectedReason}
                className={`px-4 py-2 text-[15px] font-itcbook underline ${
                observationText.trim() && selectedReason
                    ? 'text-blue cursor-pointer' 
                    : 'text-gray-400 cursor-not-allowed'
                }`}
                >
                Enviar
            </button>
        </div>
      </div>
    </div>
  );
};

export default AtcObs;